module.exports = __webpack_public_path__ + "static/img/index-v3-bg1.94dc3cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index-v3-bg1.png
// module id = KrsH
// module chunks = 68